<template>
  <slider v-if="slides.length > 0" :slides="slides" :image-width="imageWidth" :image-height="imageHeight" :space-between="2" :slides-per-view="1.5" :slides-per-view-sp="1" />
</template>

<script setup lang="ts">
import { type Slide } from '@/types/swiper';
import slider from '@/js/components/common/ui/slider.vue';

const props = defineProps<{
  slidesJson: string;
  imageWidth: number;
  imageHeight: number;
}>();
const slides: Slide[] = JSON.parse(props.slidesJson);
</script>
